export default __webpack_public_path__ + "static/media/why_hero.121f4515.jpg";